import React from 'react';
import ProductInquiryCard from '../../components/ProductInquiryCard';

const SIF = () => {
  const sectors = [
    { 
      name: "Defense Manufacturing & Aerospace", 
      cagr: "24-28% Projected", 
      desc: "Private defense contracts, indigenization mandates, and sovereign export expansion drivers." 
    },
    { 
      name: "Semiconductor & Advanced Electronics", 
      cagr: "22-26% Projected", 
      desc: "Fabless design houses, assembly packaging units (OSAT), and domestic chip supply ecosystems." 
    },
    { 
      name: "Green Hydrogen & Energy Transition", 
      cagr: "20-25% Projected", 
      desc: "Solar infrastructure developers, green hydrogen electrolyzer builders, and smart battery storage." 
    },
    { 
      name: "EV Ecosystem & Smart Mobility", 
      cagr: "18-22% Projected", 
      desc: "Battery gigafactories, precision component suppliers, charging grid operators, and telematics." 
    }
  ];

  return (
    <div className="min-h-screen bg-[#07131F] text-slate-100 selection:bg-[#16325B] selection:text-white pb-20">
      {/* Hero Section */}
      <section className="relative pt-20 pb-16 px-4 sm:px-6 lg:px-8 border-b border-slate-800/80 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none opacity-20 bg-[radial-gradient(#3B82F6_1px,transparent_1px)] [background-size:24px_24px]"></div>
        <div className="max-w-5xl mx-auto relative z-10 text-center">
          {/* <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#16325B]/40 border border-blue-500/30 text-[#60A5FA] text-xs sm:text-sm font-semibold mb-6">
            <span className="w-2 h-2 rounded-full bg-[#60A5FA] animate-pulse"></span>
            Bespoke / High-Conviction Thematic Growth
          </div> */}
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-serif font-bold text-white tracking-tight leading-tight max-w-4xl mx-auto">
            Specialized Investment Funds <span className="text-[#60A5FA]">(SIF)</span>
          </h1>
          <p className="mt-4 text-base sm:text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed">
            Targeted capital deployment into structural sunrise sectors and market niches before retail euphoria expands multiples.
          </p>
        </div>
      </section>

      {/* Metrics Bar */}
      <section className="py-10 bg-[#091B2C] border-b border-slate-800">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">Min. Investment</div>
            <div className="text-2xl font-bold text-[#60A5FA] font-mono mt-1">₹10,00,000+</div>
          </div>
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">Target Horizon</div>
            <div className="text-2xl font-bold text-white font-serif mt-1">3 – 7 Years</div>
          </div>
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">Risk Profile</div>
            <div className="text-2xl font-bold text-blue-300 font-serif mt-1">High / Concentrated Alpha</div>
          </div>
        </div>
      </section>

      {/* Main Grid */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7 space-y-4">
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-6">
              Active Thematic Pipelines
            </h2>
            {sectors.map((sec, idx) => (
              <div 
                key={idx} 
                className="p-6 rounded-2xl bg-[#0B1E30]/80 backdrop-blur-sm border border-slate-700/60 hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/10 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-lg font-bold text-white">{sec.name}</h3>
                  <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-[#16325B]/40 text-[#60A5FA] border border-blue-500/20 font-mono">
                    {sec.cagr}
                  </span>
                </div>
                <p className="text-sm text-slate-300 leading-relaxed">{sec.desc}</p>
              </div>
            ))}
          </div>

          <div className="lg:col-span-5 sticky top-24">
            <ProductInquiryCard
              title="Request SIF Term Sheet"
              subtitle="Get accredited investor PPM, sectoral allocation breakdown, and manager mandate."
              productName="Specialized Investment Funds (SIF)"
              defaultTicket="₹10,00,000+"
              buttonText="Request SIF Allocation"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default SIF;